<div class="modal1Main defaultPop">
    <div class="modalHeader">
        <span class="title">
            {{parameters.title}}
        </span>
        <button class="closepop float-right" mat-dialog-close *ngIf="parameters.cancelBtn"><i class="zmdi zmdi-close"></i></button>
    </div>
    
    <div class="defaultPopCont" *ngIf="parameters.type == 'registration_completed_popup';else defaultBody">
        <p>
            <a href="{{parameters.league_url}}">{{parameters.league_name}}</a> 
                {{parameters.body}}
            <countdown [config]="{leftTime:parameters.remaining_time, notify: [ 1 ]}" (notify)="onNotify($event)" *ngIf="(parameters.remaining_time > 3600);else reaminTimerFormatDiv">$!h!:$!m!:$!s!</countdown>

            <ng-template #reaminTimerFormatDiv>
                <countdown [config]="{leftTime:parameters.remaining_time, notify: [ 1 ]}" (notify)="onNotify($event)">$!m!:$!s!</countdown>
            </ng-template>
        </p>
    </div>
    <ng-template #defaultBody>
        <ng-container *ngIf="parameters.type == 'deposit_fee';else scheduleBody">
            <div class="fantasyGameHead" >
                <div class="row">
                    <div class="col s12 m12 l12 x12">
                    <h3 class="pT0"><img src="{{assetURL}}/assets/default/images/{{ parameters.league_type }}{{darkMode_ext}}.svg?v=2.7.5" alt="">
                        {{ parameters.name }}</h3>
                    </div> 
                </div>
            </div>
            <div class="league-balance-block"> 
                <span>Available Balance: <strong>{{parameters.balance_text}}</strong></span> 
            </div>
            <div class="league-balance-block"> 
                <span>Entry Fee: <strong>{{parameters.entry_fee}}</strong></span> 
            </div>
        </ng-container>
        <ng-template #scheduleBody>
            <div class="defaultPopCont" *ngIf="parameters.type == 'game_schedules';else firstDeposit">
                <div *ngIf="!schedulesData"> 
                    <h4 class="text-center">Loading...</h4> 
                  </div>
                  <div class="entrantsList2" *ngIf="schedulesData">
                    <perfect-scrollbar class=" maxHei400" [config]="config" style="max-width: 100%;">
                      <div *ngFor="let schedule of schedulesData.eventData">
                        <div class="entrantsDate">{{schedule.start_time}}</div>
                        <div class="entrantsBox1" *ngFor="let event of schedule.events">
                          <ul>
                            <li class="categoryName">
                              <img src="{{event.image_first}}" alt="">
                                {{event.loc_first}}
                            </li>
              
                            <li class="categoryA">@</li>
                            <li class="categoryName">
                              <img src="{{event.image_second}}" alt="">
                              {{event.loc_second}}
                            </li>
                            <li class="eventTime">
                              {{event.time_format}}
                              <span>{{event.prefix}}, {{event.time_zone}}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </perfect-scrollbar>
                </div>
            </div>
            <ng-template #firstDeposit>
                <div *ngIf="parameters.type == 'first_deposit' || parameters.type == 'deposit_success';else defaultBody">
                    <div class="defaultPopCont firstDeposit">
                        <div><i class="fas fa-gift" *ngIf="parameters.type == 'first_deposit'"></i></div>
                        <div><i class="fas fa-check" *ngIf="parameters.type == 'deposit_success'"></i></div>
                        <p [innerHTML]="parameters.body"></p>
                        <button mat-raised-button color="primary" class="joinDraftBtn" (click)="confirm('first_deposit')" *ngIf="parameters.type == 'first_deposit'">Deposit Now!</button> 
                        <button mat-raised-button color="primary" class="joinDraftBtn" (click)="confirm('deposit_success')" *ngIf="parameters.type == 'deposit_success'">Go to Lobby!</button> 
                    </div>
                </div>
                <ng-template #defaultBody>
                    <div class="defaultPopCont">
                        <p>{{parameters.body}}</p>
                    </div>
                </ng-template>
            </ng-template>
        </ng-template>
    </ng-template>
    
    <div class="text-center defaultPopfoot" *ngIf="parameters.type == 'registration_completed_popup';else defaultBottom"> 
        <button mat-raised-button color="primary" class="joinDraftBtn" (click)="confirm()">Enter Draft</button> 
    </div>
    <ng-template #defaultBottom>
        <div class="text-center defaultPopfoot" *ngIf="parameters.type == 'deposit_fee';else defaultBottom1"> 
            <button mat-raised-button color="primary" class="cancelBtn" mat-dialog-close>Cancel</button>
            <button mat-raised-button color="primary" class="joinDraftBtn" (click)="confirm('add-fund')">Deposit</button> 
        </div>
        <ng-template #defaultBottom1>
            <div class="text-center defaultPopfoot" *ngIf="parameters.type == 'session_mismatch';else defaultBottom2"> 
                <button mat-raised-button color="primary" class="joinDraftBtn" (click)="reload()">Ok</button> 
            </div>
            <ng-template #defaultBottom2>
                <div class="text-center defaultPopfoot" *ngIf="parameters.type == 'age_18' || parameters.type == 'alert-box';else defaultBottom3"></div>
                <ng-template #defaultBottom3>
                    <div class="text-center defaultPopfoot" *ngIf="parameters.type == 'eligible';else defaultBottom4"> 
                        <button mat-raised-button color="primary" (click)="confirm('location-accurate')">Accurate Location</button>
                        <button mat-raised-button color="primary" (click)="confirm('location-help')">Location Help</button> 
                    </div>
                    <ng-template #defaultBottom4>
                        <div class="text-center  defaultPopfoot" *ngIf="parameters.type == 'game_schedules';else defaultBottom5"></div>
                        <ng-template #defaultBottom5>
                            <div class="text-center" *ngIf="parameters.type == 'first_deposit' || parameters.type == 'deposit_success';else defaultBottom6"></div>
                            <ng-template #defaultBottom6>
                                <div class="text-center defaultPopfoot">
                                    <button mat-raised-button color="primary" class="cancelBtn" mat-dialog-close *ngIf="parameters.cancelBtn">Cancel</button>
                                    <button mat-raised-button color="primary" class="joinDraftBtn" (click)="confirm('')">Ok</button> 
                                </div>
                            </ng-template>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </ng-template>
        </ng-template> 
    </ng-template> 
</div>
    